import { Anchor, IconButton, mediaMixin, token } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const FloatingWidgetCSS = css`
  bottom: 0;
  display: flex;
  flex-direction: column;
  margin: 0 20px 20px 0;
  position: fixed;
  right: 0;
  width: auto;
  z-index: 9999;
  align-items: flex-end;
  justify-content: flex-end;
`;

export const StyledFloatingButtonDefault = styled(IconButton)`
  ${FloatingWidgetCSS}
`;

export const StyledFloatingButtonPropertiesPage = styled(IconButton)`
  ${FloatingWidgetCSS}
  margin-bottom: 10vh;
  ${mediaMixin(
    'sm_lte',
    css`
      margin-bottom: 15vh;
    `,
  )};
`;

export const StyledAnchor = styled(Anchor)`
  color: ${token('colors.black')};

  &:visited {
    color: ${token('colors.black')};
  }
`;
